import {ActionTypes} from '../actions';
import createReducer from '../../common/util/createReducer';

const INITIAL_STATE = {
  'loading': false,
};

export const excelReader = (state, action) => {
  return createReducer(INITIAL_STATE, {
    [ActionTypes.LOADING_EXCEL_DATA]: (state, action) => ({
      ...state,
      'loading': action.payload,
    }),
  })(state, action);
};
